import { API_HR_PATH, getClient } from '../api';
import {
  Applicant, HireApplicantResponse, HireApplicant,
} from '../dtos';

export async function getApplicant(applicantId: number): Promise<Applicant> {
  const client = await getClient();
  const { data } = await client.get<Applicant>(`${API_HR_PATH}/applicants/${applicantId}`);

  return data;
}

export async function updateApplicant(applicantId: number, applicant: Applicant): Promise<Applicant> {
  const client = await getClient();
  const { data } = await client.put<Applicant>(`${API_HR_PATH}/applicants/${applicantId}`, applicant);

  return data;
}

export async function createApplicant(applicant: Applicant): Promise<Applicant> {
  const client = await getClient();
  const { data } = await client.post<Applicant>(`${API_HR_PATH}/applicants`, applicant);

  return data;
}

export async function hireApplicant(hire: HireApplicant): Promise<HireApplicantResponse> {
  const client = await getClient();
  const { data } = await client.post<HireApplicantResponse>(`${API_HR_PATH}/applicants/hire`, hire);
  return data;
}

export async function getSimilarApplicants(applicantId: number): Promise<Applicant[]> {
  const client = await getClient();
  const { data } = await client.get<Applicant[]>(`${API_HR_PATH}/applicants/${applicantId}/similar`);

  return data;
}
